let activeCustomerRegardId: null | string = null

/**
 * Holds the active customer's `customer_regard_id` so the RTK Query base query — which
 * runs outside React and so cannot call `useParams` — can read it. Mirrors the `sec`
 * token bridge in `security.ts`, and is kept in sync from `CareGapsLayout`, which owns
 * the `/c/:customer/` route segment.
 *
 * `get` returns `null` outside a customer-scoped route rather than falling back to a
 * customer of its own, because "no customer" is a state the shell has to be able to
 * express: `Bootstrap` runs at `/`, above any `/c/:customer/` route, and asks for the
 * accessible customer list precisely in order to find out which customer to use. A
 * fallback here would scope that request to whichever customer it named, so the request
 * that resolves the customer would already presume one. The base query appends the param
 * only when this is set, so an unscoped request simply omits it.
 */
export const customerHolder = {
  get: (): null | string => activeCustomerRegardId,

  set: (customerRegardId: null | string) => {
    activeCustomerRegardId = customerRegardId
  },
}
